/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Button, Modal } from "antd";
import { useAppSelector } from "hooks/reduxHooks";

interface TemplateInstructionsProps {
  open: boolean;
  onClose: () => void;
}

const TemplateInstructions: React.FC<TemplateInstructionsProps> = ({
  open,
  onClose,
}: TemplateInstructionsProps) => {
  
  const lockerDetails: any = useAppSelector((state: any) => state.landingPage.lockerPortalDetails);
  const templateAttribute = lockerDetails?.lockerPortalDetails?.Attributes?.Attributes?.find(
    (attribute: any) => attribute?.AttributeCode === "TemplateInstructions"
  );

  return (
    <Modal
      open={open}
      title="Template Instructions"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      centered={true}
    >
      {templateAttribute?.AttributeValue}
    </Modal>
  );
};

export default TemplateInstructions;
